import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/intellectual-property-notice/content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/PageLayout/index.tsx");
